import React, { useState, useEffect } from "react";

import { TextField, Button,
  Dialog, DialogActions, DialogContent,
  DialogTitle, Slide, IconButton,
} from "@mui/material";

import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from "@mui/material";

import { crearGrupo, editarGrupo } from "../../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { useAppDispatch, useAppSelector } from '../../provider/app/hooks';
import { addItem, updateItem } from '../../provider/Slice/GruposSlice';
import { InputStyle, RadioButton } from "../../SXStyle";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogGroup({ open, setOpen, registro = null , setSnackbar }) {
  
  const dispatch = useAppDispatch();

  //react-hook-form
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      type: "",
      description: "",
      status: "1",
    }
  });

  const handleDialogClose = () => {
    setOpen(false);
  };

  //si es un edit - llena los valores del registro
  //si es un nuevo registro - valores por default
  useEffect(() => {
    if(registro !== null && open)
    {
      reset({
        id: registro.id,
        name: registro.name,
        type: registro.type,
        description: registro.description,
        status: registro.status
      })
    }
    else if (registro === null && open) {
      reset({
        id: null,
        name: "",
        type: "",
        description: "",
        status: "1",
      });
    }

  },[registro, open, reset])

  //guarda el registro
  const onSubmit = async (data) => {
    
    try {
      let result;

      const cacheUsuario = JSON.parse(localStorage.getItem('sesionIniciada'));
     
      //edita el registro
      if(registro && registro.id)
      {
        result = await editarGrupo({...data, created_by: cacheUsuario.id} , registro.id);
        dispatch(updateItem(result.data));
      }
      else if(!registro) //nuevo registro
      {
        result = await crearGrupo({...data, created_by: cacheUsuario.id});
        dispatch(addItem(result.data));
      }

      //si las credenciales son invalidas
      if (result)
        setSnackbar({ message: result.message, open: true });
    } 
    catch (error) {
      console.log({ error });
      setSnackbar({ message: "Ocurrió un error inesperado, intente de nuevo", open: true });
    }

    //limpia los datos despues de mandar una solicitud
    reset();

    handleDialogClose();
  };


  return (
    <React.Fragment>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
          },
        }}
      >
        <DialogTitle>
          <p className="text-white font-bold"> Crear Grupo </p>
        </DialogTitle>
        
        <DialogContent>
          <form
            id="mi-formulario"
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Controller
              name="name"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nombre"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.name}
                  helperText={errors.name ? "Campo faltante  o inválido" : ""}
                />
              )}
            />
            
            <Controller
              name="type"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Tipo"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.type}
                  helperText={errors.type ? "Campo faltante  o inválido" : ""}
                />
              )}
            />

            <Controller
              name="description"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Descripción"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.description}
                  helperText={errors.description ? "Campo faltante  o inválido" : ""}
                  multiline
                  rows={2}
                />
              )}
            />

            <FormControl component="fieldset" error={!!errors.status}>
              <Controller
                name="status"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <RadioGroup {...field}>
                    <FormControlLabel
                      value="1"
                      control={<Radio sx={RadioButton} />}
                      label="Activo"
                      sx={{ color: "#fffcfc" }}
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio sx={RadioButton} />}
                      label="Inactivo"
                      sx={{ color: "#fffcfc" }}
                    />
                  </RadioGroup>
                )}
              />
              {errors.status && (
                <span style={{ color: "red" }}>Debes elegir una opción</span>
              )}
            </FormControl>
          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cancelar </p>
          </Button>
          <Button type="submit" form="mi-formulario">
            <p className="text-amarillo"> Aceptar </p>
          </Button>
        </DialogActions>
      
      </Dialog>
    </React.Fragment>
  );
}

export default DialogGroup;
